module.exports = __webpack_public_path__ + "img/scalability-4.247d7433.png";